import React from 'react';

type Props = {
  children?: React.ReactNode;
};

const EmptyLayout = ({ children }: Props) => <div>{children}</div>;

export default EmptyLayout;
